module.exports = __webpack_public_path__ + "img/ficha.381d8d66.png";